import React from 'react';
import {Icon, Anchor, Text} from '@albert-io/atomic';

interface Props {
  supportingTitleText?: string;
}

const MegaClassesEmptyState = ({supportingTitleText = 'Data will not load'}: Props) => {
  return (
    <div className='u-display_flex u-flex-direction_column u-align-items_center u-justify-content_center u-border u-border-color_slate-200 u-border-radius_1 u-pad-lr_5 u-pad-tb_7 u-max-width_default u-mar-lr_auto u-mar-t_2'>
      <Icon icon='info-circle' iconStyle='light' className='fa-2x' />
      <Text bold className='u-mar-t_2'>
        This class is too large. {supportingTitleText}.
      </Text>
      <div className='u-display_flex u-flex-direction_column u-align-items_center'>
        <Text className='u-mar-t_1'>For questions about accessing this data,</Text>
        <Text className='u-mar-t_0'>
          please contact{' '}
          <Anchor as='a' href='mailto:hello@albert.io?subject=Large classroom data question'>
            hello@albert.io
          </Anchor>
        </Text>
      </div>
    </div>
  );
};

export default MegaClassesEmptyState;
